import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { push } from "connected-react-router";
import { isEmpty } from "lodash";
import { actions as formActions } from "reducers/form";

export const useTransaction = (signAction, cleanAction, formatTransaction) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const dispatch = useDispatch();
    const { transaction, fetching: isLoading } = useSelector((_state) => _state.form);

    const { user } = useSelector((_state) => _state.session);

    const showSignButton = isEmpty(transaction?.signatures?.find((sign) => sign.idUser === user?.userId));
    const isBackoffice = pathname.includes("backoffice");

    const handleSignTransaction = () => {
        const { data, idTransaction } = transaction;
        const formatDataToSign = formatTransaction(data, idTransaction);
        dispatch(signAction(formatDataToSign));
    };

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readAgreementTransaction(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(cleanAction());
        },
        [],
    );

    return { isLoading, transaction, handleSignTransaction, showSignButton, push, dispatch, id, isBackoffice };
};

export default useTransaction;
